import React from "react";
import {
  ReferenceField,
  FunctionField,
  ReferenceInput,
  SelectInput,
  required,
  Create,
  SimpleForm
} from "react-admin";

const SeasonCodeInput = () => (
  <ReferenceInput
    label="Season"
    source="seasonCode"
    reference="availableSeasons"
  >
    <SelectInput
      optionText="label"
      optionValue="code"
      validate={[required()]}
    />
  </ReferenceInput>
);

const SeasonTeamCreate = (props) => {
  const redirect = function (basePath, id, data) {
    return `/teams/${data.team.id}/show/1`;
  };

  return (
    <Create {...props}>
      <SimpleForm redirect={redirect}>
        <ReferenceField label="Team" source="team_id" reference="teams">
          <FunctionField
            label="Team"
            render={(record) => `${record.name} (${record.id})`}
          />
        </ReferenceField>
        <ReferenceField label="Sport" source="sportCode" reference="sportCodes">
          <FunctionField
            label="Sport"
            render={(record) => `${record.label} (${record.id})`}
          />
        </ReferenceField>
        <SeasonCodeInput />
      </SimpleForm>
    </Create>
  );
};

export default SeasonTeamCreate;
